module.exports = __webpack_public_path__ + "img/ring_g_skip_0_1@2x.e555a0cd.png";